(() => {
  const desktop = window.matchMedia('(min-width: 990px)');

  function hydrateFeatureImage(details) {
    if (!desktop.matches) return;
    const image = details.querySelector('img[data-market-menu-src]');
    if (!image || image.getAttribute('src')) return;
    image.src = image.dataset.marketMenuSrc;
    if (image.dataset.marketMenuSrcset) image.srcset = image.dataset.marketMenuSrcset;
  }

  function closeOthers(root, current) {
    root.querySelectorAll('.seibertron-market-menu__details[open]').forEach((details) => {
      if (details !== current) details.removeAttribute('open');
    });
  }

  document.querySelectorAll('[data-seibertron-market-menu="de"]').forEach((root) => {
    if (root.dataset.marketMenuReady === 'true') return;
    root.dataset.marketMenuReady = 'true';

    root.querySelectorAll('.seibertron-market-menu__details').forEach((details) => {
      const summary = details.querySelector(':scope > summary');
      if (!summary) return;

      details.addEventListener('toggle', () => {
        if (!details.open) return;
        closeOthers(root, details);
        hydrateFeatureImage(details);
      });

      details.addEventListener('pointerenter', (event) => {
        if (!desktop.matches || event.pointerType === 'touch') return;
        closeOthers(root, details);
        details.setAttribute('open', '');
        hydrateFeatureImage(details);
      });

      details.addEventListener('pointerleave', (event) => {
        if (!desktop.matches || event.pointerType === 'touch') return;
        details.removeAttribute('open');
      });

    });

    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openDetails = event.target.closest('.seibertron-market-menu__details') || root.querySelector('.seibertron-market-menu__details[open]');
      if (!openDetails) return;
      openDetails.removeAttribute('open');
      const summary = openDetails.querySelector(':scope > summary');
      if (summary) summary.focus();
    });

    document.addEventListener('click', (event) => {
      if (!root.contains(event.target)) closeOthers(root, null);
    });
  });
})();
